export default "__VITE_ASSET__BxCbXS_5__"